import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_GET_INDUSTRY_CONTENT } from '../utils/apis';
import fetchWrapper from '../utils/httpClient';

export const fetchIndustryContent = createAsyncThunk(
  'home/fetchIndustryContent',
  async (params, { rejectWithValue }) => {
    try {
      const defaultParams = {
        region: 'SG',
        type: 'homePage'
      };

      const normalizedParams = { ...defaultParams, ...params };
      const { language, region, type, page } = normalizedParams;

      if (!language || !page) {
        throw new Error('Language and page parameters are required');
      }

      const queryParams = new URLSearchParams({
        language,
        region,
        type,
        page
      });

      const response = await fetchWrapper.get(
        `${API_GET_INDUSTRY_CONTENT}?${queryParams.toString()}`
      );

      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to fetch industry content'
      });
    }
  }
);

export const saveIndustryContent = createAsyncThunk(
  'home/saveIndustryContent',
  async (params, { rejectWithValue }) => {
    try {
      const { language, region, type, page, contentData } = params;

      if (!language || !page || !contentData) {
        throw new Error('Language, page and contentData parameters are required');
      }

      const requestBody = {
        language,
        region: region || 'SG',
        type: type || 'homePage',
        page,
        contentData
      };

      const response = await fetchWrapper.post(
        '/cms/api/industry/content',
        requestBody
      );

      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to save industry content'
      });
    }
  }
);

const homeSlice = createSlice({
  name: 'home',
  initialState: {
    industryContent: null,
    loading: false,
    error: null,
    success: false
  },
  reducers: {
    resetIndustryContent: (state) => {
      state.industryContent = null;
      state.loading = false;
      state.error = null;
      state.success = false;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIndustryContent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIndustryContent.fulfilled, (state, action) => {
        state.loading = false;
        state.industryContent = action.payload;
        state.success = true;
      })
      .addCase(fetchIndustryContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })

      .addCase(saveIndustryContent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveIndustryContent.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(saveIndustryContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const {
  resetIndustryContent,
  clearError
} = homeSlice.actions;

export const selectIndustryContent = (state) => state.home.industryContent;
export const selectIndustryContentLoading = (state) => state.home.loading;
export const selectIndustryContentError = (state) => state.home.error;
export const selectIndustryContentSuccess = (state) => state.home.success;


export default homeSlice.reducer;